/**
 * @file: 获取适合画布缩放比例
 * @author: xiaolong.huang@dmall.com
 */

import * as StageStatus from '../../stageStatus';
import Utils from '../../utils/util';
import { shelfTotalWidth, shelfsMaxLogicHeight } from '../../UIToolkit/shelf/shelfCodi';
import { freezerTotalWidth, freezerMaxLogicHeight } from '../../UIToolkit/freezer/freezerCodi';

interface ShelfLogicSize {
    width: LogicsicsMeasurement,
    height: LogicsicsMeasurement
};

function fullscreenScale(): number {
    let $sketchpad: JQuery<HTMLElement> = $('.shelvesbuild-e-sketchpad');
    let $sketchpadWidth: number = $sketchpad.width();
    let $sketchpadHeight: number = $sketchpad.height();
    let shelfLogicSize: ShelfLogicSize = getShelfLogicSize();
    let shelfAreaWidth: LogicsicsMeasurement = shelfLogicSize.width;
    let shelfAreaHeight: LogicsicsMeasurement = shelfLogicSize.height;
    let scale: number = Utils.math($sketchpadWidth, shelfAreaWidth, '/');

    if (shelfAreaWidth / shelfAreaHeight > $sketchpadWidth / $sketchpadHeight) {
        scale = Utils.math($sketchpadWidth, shelfAreaWidth, '/');
    }
    else {
        scale = Utils.math($sketchpadHeight, shelfAreaHeight, '/');
    }

    return scale;
}

function getShelfLogicSize(): ShelfLogicSize {
    if (StageStatus.isTopFace()) {
        return {
            width: freezerTotalWidth() + 100,
            height: freezerMaxLogicHeight() + 100
        };
    }

    return {
        width: shelfTotalWidth() + 100,
        height: shelfsMaxLogicHeight() + 100
    };
}

export {
    fullscreenScale
};
